import { BaseController } from 'controllers/BaseController'
import { OnRequestChangeCallback } from 'services/APIs/BaseAPI'
import { PdfViewerModel } from 'services/APIs/InternalAPI/internal-api.contracts'
import { InternalAPI } from 'services/APIs/InternalAPI/InternalAPI'
import { GetContext } from 'store/storeUtils'

interface IBomItemPdfViewerAPI {
  GetPDFViewer: (bomItemId: string) => Promise<PdfViewerModel>
  DeletePdfPage: (bomItemId: string, pageId: string) => Promise<PdfViewerModel>
}

class BomItemPdfViewerAPI extends InternalAPI implements IBomItemPdfViewerAPI {
  constructor(
    partyId: string,
    projectId: string,
    onRequestChange: OnRequestChangeCallback,
  ) {
    super(
      `/api/parties/${partyId}/projects/${projectId}/bomItem`,
      onRequestChange,
    )
  }

  async GetPDFViewer(bomItemId: string): Promise<PdfViewerModel> {
    return this.GetAsync<PdfViewerModel>({
      id: PdfViewerAPIIds.GetPdfViewer(bomItemId),
      relativePath: `/${bomItemId}/pdfViewer`,
    })
  }

  async DeletePdfPage(
    bomItemId: string,
    pageId: string,
  ): Promise<PdfViewerModel> {
    return await this.DeleteAsyncWithResp<PdfViewerModel>({
      relativePath: `/${bomItemId}/pdfViewer/page/${pageId}`,
    })
  }
}

export const PdfViewerAPIIds = {
  GetPdfViewer: (bomItemId: string) => `GetPdfViewer-${bomItemId}`,
}

export class PdfViewerController extends BaseController<IBomItemPdfViewerAPI> {
  constructor() {
    super((onRequestChange) => {
      const { partyId, projectId } = GetContext()
      return new BomItemPdfViewerAPI(partyId, projectId, onRequestChange)
    })
  }

  async GetPDFViewer(bomItemId: string): Promise<PdfViewerModel> {
    try {
      const result = await this.api.GetPDFViewer(bomItemId)
      return result
    } catch (error) {
      throw this.HandleError(error) ?? error
    }
  }

  async DeletePdfPage(
    bomItemId: string,
    pageId: string,
  ): Promise<PdfViewerModel> {
    try {
      return await this.api.DeletePdfPage(bomItemId, pageId)
    } catch (error) {
      throw this.HandleError(error)
    }
  }
}
